import { Component, EventEmitter, Input, Output, ElementRef, ViewChild, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import { EcatService } from 'src/app/services/ecat.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
    selector: 'app-multi-search',
    templateUrl: './custom-multi-search.component.html',
    styleUrls: ['./custom-multi-search.component.less']
})
export class CustomMultiSearchComponent {
    // 外部传入的下拉候选项
    @Input() options: string[] = [];
    @Input() placeholder = '';
    @Input() selectedItems: string[] = [];
    @Output() selectedObjectChange = new EventEmitter<string[]>();
    @Output() selectedIndexChange = new EventEmitter<number>();
    // 当点击搜索或值改变时触发
    @Output() search = new EventEmitter<string[]>();

    @ViewChild('inputField') inputField!: ElementRef;

    inputValue: string = '';      // 输入框当前文本
    isDropdownOpen: boolean = false;
    selectOptions: any[] = [];


    constructor(private elementRef: ElementRef, private router: Router, private ecatService: EcatService,
        private message: NzMessageService,) { }

    // 根据输入过滤后的下拉选项
    // get filteredOptions(): string[] {
    //     if (!this.inputValue) return this.options;
    //     return this.options.filter(opt =>
    //         opt.toLowerCase().includes(this.inputValue.toLowerCase()) &&
    //         !this.selectedItems.includes(opt) // 过滤掉已选的
    //     );
    // }

    addItem(item: any) {
        // if (item && !this.selectedItems.includes(item)) {
        //     this.selectedItems.push(item);
        //     this.updateModel(); // <--- 3. 每次修改后触发更新
        // }
        this.selectedItems.push(item.brandName);
        this.selectedItems.push(item.modelClass);
        this.updateModel(item);
        this.inputValue = '';
        this.isDropdownOpen = false;
        this.inputField.nativeElement.focus();
    }

    removeItem(index: number, event: Event) {
        event.stopPropagation();
        if (index === 0) {
            this.selectedItems.splice(index);
        } else {
            this.selectedItems.splice(1);
        }
        // this.updateModel(); // <--- 3. 每次修改后触发更新
        this.selectedIndexChange.emit(index);
        this.selectOptions = [];
        this.inputValue = '';
    }

    clearAll(event: Event) {
        event.stopPropagation();
        this.selectedItems.splice(0);
        this.inputValue = '';
        // this.updateModel(); // <--- 3. 每次修改后触发更新
        // this.inputField.nativeElement.focus();
        this.selectedIndexChange.emit(0);
        this.selectOptions = [];
        this.inputValue = '';
    }

    // 辅助方法：通知父组件数据已改变
    private updateModel(item: any) {
        this.selectedObjectChange.emit(item);
    }

    // 触发最终搜索
    onSearchClick() {
        if (this.inputValue === '') {
            this.message.create('warning', '请输入品牌或车型名称');
        } else {
            this.ecatService.fuzzySearch({ queryKey: this.inputValue }).subscribe(result => {
                const { resultCode, resultData } = result;
                this.selectOptions = resultData.searchList;
                if (resultData.searchList.length === 0) {
                    this.message.create('warning', '没有查询到匹配结果');
                }
            })
        }
    }

    // 处理键盘事件
    onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter') {
            event.preventDefault(); // 防止表单提交
            // if (this.inputValue.trim()) {
            //     // 支持自定义输入：即使不在下拉框中也可以添加
            //     this.addItem(this.inputValue.trim());
            // } else {
            //     // 如果输入框为空按回车，触发搜索
            //     this.onSearchClick();
            // }
            this.onSearchClick();
        } else if (event.key === 'Backspace' && this.inputValue === '' && this.selectedItems.length > 0) {
            // 当输入框为空按退格键，删除最后一个标签
            this.selectedItems.pop();
        }
    }

    // 处理输入框聚焦
    onFocus() {
        this.isDropdownOpen = true;
    }

    // 点击组件外部关闭下拉
    @HostListener('document:click', ['$event'])
    onClickOutside(event: Event) {
        const target = event.target as HTMLElement;
        // 如果点击的不是组件内部元素
        if (!this.elementRef.nativeElement.contains(target)) {
            this.isDropdownOpen = false;
        }
    }
}